import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Heart, X, UserPlus, LogIn } from "lucide-react";
import { useAuth } from "./authApi";

export function FavoriteAccountPrompt() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onNeed = () => { if (!user) setOpen(true); };
    window.addEventListener("omk-need-account", onNeed);
    return () => window.removeEventListener("omk-need-account", onNeed);
  }, [user]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[70] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(false)} data-testid="favorite-account-prompt">
          <motion.div initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, opacity: 0 }} onClick={(e) => e.stopPropagation()} className="relative max-w-md w-full bg-[#0d0d10] border border-[#C19A6B]/30 p-8 text-center">
            <button onClick={() => setOpen(false)} data-testid="fav-prompt-close" className="absolute top-3 right-3 text-zinc-500 hover:text-white"><X className="w-5 h-5" /></button>
            <div className="w-14 h-14 mx-auto rounded-full bg-[#C19A6B]/15 flex items-center justify-center mb-4"><Heart className="w-6 h-6 text-[#C19A6B] fill-[#C19A6B]" /></div>
            <h3 className="text-xl font-light text-white">Bien ajouté à vos favoris</h3>
            <p className="text-sm text-zinc-400 mt-2 leading-relaxed">Créez votre compte gratuit pour <span className="text-[#C19A6B]">enregistrer vos favoris</span>, les retrouver sur tous vos appareils et être alerté des nouveautés.</p>
            <div className="flex flex-col gap-2.5 mt-6">
              <Link to="/inscription" data-testid="fav-prompt-register" onClick={() => setOpen(false)} className="inline-flex items-center justify-center gap-2 bg-[#C19A6B] hover:bg-[#d1af84] text-white font-medium uppercase tracking-wider text-sm py-3 transition-colors"><UserPlus className="w-4 h-4" /> Créer mon compte</Link>
              <Link to="/connexion" data-testid="fav-prompt-login" onClick={() => setOpen(false)} className="inline-flex items-center justify-center gap-2 border border-white/15 text-zinc-200 hover:border-[#C19A6B] hover:text-[#C19A6B] font-medium uppercase tracking-wider text-sm py-3 transition-colors"><LogIn className="w-4 h-4" /> J'ai déjà un compte</Link>
              <button onClick={() => setOpen(false)} data-testid="fav-prompt-skip" className="text-xs text-zinc-500 hover:text-zinc-300 mt-1 transition-colors">Continuer sans compte</button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
